"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContaminationOfRoAbilityHandler = exports.ContaminationOfRoActorAbilityFactory = exports.ContaminationOfRoAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Poisoned_1 = require("../../core/effects/core/Poisoned");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
class ContaminationOfRoAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ContaminationOfRo;
        this.__typeName = "ContaminationOfRo";
    }
}
exports.ContaminationOfRoAbilityArgs = ContaminationOfRoAbilityArgs;
let ContaminationOfRoActorAbilityFactory = class ContaminationOfRoActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ContaminationOfRo", "AllEnemies", 1);
    }
};
ContaminationOfRoActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ContaminationOfRo")
], ContaminationOfRoActorAbilityFactory);
exports.ContaminationOfRoActorAbilityFactory = ContaminationOfRoActorAbilityFactory;
let ContaminationOfRoAbilityHandler = class ContaminationOfRoAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Nature", 40)
                ],
            })),
            onDamage(sequence, target, _attack, damages) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: target.targetId,
                    duration: Duration_1.Duration.Ticks(8),
                    effect: new Poisoned_1.PoisonedEffectArgs("Power", 10)
                });
            },
        });
    }
};
ContaminationOfRoAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ContaminationOfRo)
], ContaminationOfRoAbilityHandler);
exports.ContaminationOfRoAbilityHandler = ContaminationOfRoAbilityHandler;
